import { Menu, MenuProps, Typography } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';

import { defaultAdminIcon, findAdminLink } from '@/components/Admin/adminNav';
import { AdminSidebarProps } from '@/types/components';

const { Text } = Typography;
type MenuItem = Required<MenuProps>['items'][number];

export default function Sidebar({
  links,
  collapsed = false,
  onNavigate,
}: AdminSidebarProps) {
  const navigate = useNavigate();
  const location = useLocation();

  // 依 group 欄位把導覽項目分組，保留原本順序
  const groups: { title: string; items: MenuItem[] }[] = [];
  links.forEach((link) => {
    const title = link.group ?? '';
    let group = groups.find((g) => g.title === title);
    if (!group) {
      group = { title, items: [] };
      groups.push(group);
    }
    group.items.push({
      key: link.to,
      icon: link.icon ?? defaultAdminIcon,
      label: link.label,
    });
  });

  const menuItems: MenuItem[] = groups.map((group) =>
    group.title
      ? {
          type: 'group',
          key: `group-${group.title}`,
          label: collapsed ? null : group.title,
          children: group.items,
        }
      : (group.items[0] as MenuItem),
  );

  const activeKey = findAdminLink(location.pathname)?.to ?? location.pathname;

  const handleMenuClick: MenuProps['onClick'] = (e) => {
    navigate(e.key);
    onNavigate?.();
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div
        style={{
          height: 64,
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          padding: collapsed ? 0 : '0 20px',
          justifyContent: collapsed ? 'center' : 'flex-start',
          borderBottom: '1px solid #e8ece5',
          flexShrink: 0,
        }}
      >
        <div
          style={{
            width: 32,
            height: 32,
            borderRadius: 8,
            background: 'linear-gradient(135deg, #8fb27a, #5b7d49)',
            color: '#fff',
            fontWeight: 700,
            fontSize: 13,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          SDG
        </div>
        {!collapsed && (
          <div style={{ lineHeight: 1.25, minWidth: 0 }}>
            <Text strong style={{ display: 'block', fontSize: 15 }}>
              SDGs 自評系統
            </Text>
            <Text type="secondary" style={{ fontSize: 12 }}>
              後台管理
            </Text>
          </div>
        )}
      </div>

      <Menu
        mode="inline"
        selectedKeys={[activeKey]}
        items={menuItems}
        onClick={handleMenuClick}
        style={{
          border: 'none',
          background: 'transparent',
          padding: '12px 8px',
          flex: 1,
          overflowY: 'auto',
        }}
      />
    </div>
  );
}
